<script>
import TrackedPage from '@/mixins/TrackedPage';
import ValidationObserver from '@/mixins/ValidationObserver';
import ScrollToTop from '@/mixins/ScrollToTop';

export default {
  name: 'WizardPage',
  mixins: [TrackedPage, ValidationObserver, ScrollToTop],
  props: {
    onNext: {
      type: Function,
      required: true,
    },
    onComplete: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      locked: false,
    };
  },
  methods: {
    async lockAndExec(func) {
      if (!this.locked) {
        this.locked = true;
        try {
          await func();
        } finally {
          this.locked = false;
        }
      }
    },
    async nextPage() {
      await this.lockAndExec(async () => {
        const { valid } = await this.validate();
        if (valid) {
          await this.onNext();
        }
      });
    },
    async complete() {
      await this.lockAndExec(async () => {
        const { valid } = await this.validate();
        if (valid) {
          await this.onComplete();
        }
      });
    },
  },
};
</script>
